import React, { useContext, useState, useEffect } from "react";
import ReactDOM from "react-dom";
import { FaTimes, FaChevronRight, FaArrowLeft, FaUserCircle } from "react-icons/fa";
import { Link, useNavigate } from "react-router-dom";
import { AuthContext } from "../context/AuthContext";
import "./SideCategoryMenu.css";

function SideCategoryMenu({ categories, isOpen, setIsOpen }) {
  const { user } = useContext(AuthContext);
  const navigate = useNavigate();
  const [activeSubMenu, setActiveSubMenu] = useState(null);

  // Close sub-menu on sidebar close
  useEffect(() => {
    if (!isOpen) {
      const timer = setTimeout(() => setActiveSubMenu(null), 300);
      return () => clearTimeout(timer);
    }
  }, [isOpen]);

  const mainCategories = categories.filter((cat) => cat.parent === 0);
  const getSubCategories = (parentId) => categories.filter((cat) => cat.parent === parentId);

  const handleCategoryClick = (cat, subs) => {
    if (subs.length > 0) {
      setActiveSubMenu(cat); // Open sub-menu if subs exist
    } else {
      setIsOpen(false);
      navigate(`/category/${cat.slug}`); // Navigate if no subs
    }
  };

  const menuContent = (
    <div className={`side-menu-container ${isOpen ? "open" : ""}`}>
      {/* 1. Dark Overlay */}
      <div className="side-overlay" onClick={() => setIsOpen(false)}></div>

      {/* 2. Sidebar Body */}
      <div className="side-panel">
        
        {/* --- HEADER --- */}
        <div className="side-header">
          <div className="user-info">
            <FaUserCircle size={24} />
            <h3>Hello, {user ? user.name : "Sign In"}</h3>
          </div>
          <div className="close-icon" onClick={() => setIsOpen(false)}>
            <FaTimes size={22} />
          </div>
        </div>

        {/* --- CONTENT AREA --- */}
        <div className="side-body">
          
          {/* Main Menu Panel */}
          <div className={`menu-panel main-panel ${activeSubMenu ? "panel-left" : "panel-active"}`}>
            <h4 className="section-title">Shop by Category</h4>
            
            {mainCategories.map((cat) => {
              const subs = getSubCategories(cat.id);
              return (
                <div key={cat.id} className="menu-item" onClick={() => handleCategoryClick(cat, subs)}>
                  <span>{cat.name}</span>
                  {subs.length > 0 && <FaChevronRight size={12} className="gray-arrow" />}
                </div>
              );
            })}

            <div className="side-divider"></div>
            
            <h4 className="section-title">Help & Settings</h4>
            <Link to="/orders" className="menu-item link-only" onClick={() => setIsOpen(false)}>My Orders</Link>
            <Link to="/contact" className="menu-item link-only" onClick={() => setIsOpen(false)}>Customer Service</Link>
          </div>

          {/* Sub Menu Panel */}
          {activeSubMenu && (
            <div className={`menu-panel sub-panel panel-active`}>
              <div className="back-btn" onClick={() => setActiveSubMenu(null)}>
                <FaArrowLeft size={14} /> <span>MAIN MENU</span>
              </div>
              
              <h4 className="section-title">{activeSubMenu.name}</h4>
              
              <Link 
                to={`/category/${activeSubMenu.slug}`} 
                className="menu-item bold-link" 
                onClick={() => setIsOpen(false)}
              >
                See all {activeSubMenu.name}
              </Link>

              {getSubCategories(activeSubMenu.id).map((sub) => (
                <Link 
                  key={sub.id} 
                  to={`/category/${sub.slug}`} 
                  className="menu-item link-only" 
                  onClick={() => setIsOpen(false)}
                >
                  {sub.name}
                </Link>
              ))}
            </div>
          )}
        </div>
      </div>
    </div>
  );

  return ReactDOM.createPortal(menuContent, document.body);
}

export default SideCategoryMenu;